// ----------------------------
// Created by Bulletproof Games
//            2021
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Game Loader
//

Loader = {};
Loader.isLoaded = false;
Loader.minTimerExpired = false;
Loader.readyForSplash = false;

autoplayManager.containerName = 'autoplayContainer:autoplayBackground';

Loader.initialise = function (container) {
  Loader.container = container;

  // Setup callback functions
  resourceManager.registerLoadCompleteCallback(Loader.onLoadComplete);
  resourceManager.registerLoadProgressCallback(Loader.onLoadProgress);
  Reflex.registerEventHandler('ready', Loader.onLayoutComplete);
};

Loader.onResize = function (width, height, isLandscape) {
  if (Loader.loaderBackground !== undefined) {
    var scale = Math.max(
      width / Loader.loaderBackground.texture.width,
      height / Loader.loaderBackground.texture.height
    );
    Loader.loaderBackground.scale.x = scale;
    Loader.loaderBackground.scale.y = scale;
    Loader.loaderBackground.position.x = width / 2;
    Loader.loaderBackground.position.y = height / 2;
  }
};

Loader.onLoadComplete = function (loadGroup, resources) {
  if (loadGroup === 'loading') {
    globalThis.__PIXI_STAGE__ = systemData.stage;
    globalThis.__PIXI_RENDERER__ = systemData.renderer;

    Loader.progressBar = resourceManager.get('loadingBarContainer:loadingProgressFill');

    resourceManager.getContainer('loadingbackgroundContainer').visible = true;
    resourceManager.getContainer('loadingbackgroundContainerPortrait').visible = true;
    resourceManager.getContainer('bigWinBgContainer').visible = false;
    resourceManager.getContainer('backgroundContainer').visible = false;
    resourceManager.getContainer('backgroundContainerPortrait').visible = false;
    resourceManager.getContainer('splashBackgroundContainer').visible = false;
    resourceManager.getContainer('splashBackgroundContainerPortrait').visible = false;
    resourceManager.getContainer('splashContainer').visible = false;
    resourceManager.getContainer('popupContainer').visible = false;

    Loader.loadMask = resourceManager.get('loadingBarContainer:loadingMask');
    Loader.loadMask.beginFill(0xffffff);
    Loader.loadMask.drawRect(0, 0, 74, 724);
    Loader.loadMask.endFill();

    Loader.loadMask.pivot.y = 0;
    Loader.loadMask.scale.y = 0;
    Loader.progressBar.mask = Loader.loadMask;

    Loader.setLoadProgress(0);

    const loadingData = gdk.getPlatformLoadingData();
    let isGamCareLogoVisible = checkForDefined(loadingData.gamCareLogo) ? loadingData.gamCareLogo : false;
    let isPreloadMessageVisible = checkForDefined(loadingData.message);
    resourceManager.get('GamCareContainerPreLoad:gamCareLogo').visible = isGamCareLogoVisible;
    resourceManager
      .get('GamCareContainerPreLoad:preLoadMessage')
      .setText(isPreloadMessageVisible ? loadingData.message : '');
    resourceManager.get('GamCareContainerPreLoad').visible =
      isGamCareLogoVisible || (isPreloadMessageVisible && loadingData.message.length != 0);

    if (isPreloadMessageVisible && !Reflex.developerMode) {
      // YG requirement, we need to give player 5 seconds to read preloader message
      timerManager.addTimer(5000, undefined, function () {
        Loader.minTimerExpired = true;
        Loader.checkCanGoToSplash();
      });
    } else {
      Loader.minTimerExpired = true;
      Loader.checkCanGoToSplash();
    }
  }

  if (loadGroup === 'mainGame') {
    resourceManager.getContainer('mobileMeterPanel').visible = false;
  }
};

Loader.onLoadProgress = function (percent, loadGroup) {
  if (loadGroup !== 'loading') {
    Loader.setLoadProgress(percent);
  }
};

Loader.showGameCare = function () {
  var loadingData = gdk.getPlatformLoadingData();
  let isGamCareLogoVisible = checkForDefined(loadingData.gamCareLogo) ? loadingData.gamCareLogo : false;
  let isPreloadMessageVisible = checkForDefined(loadingData.message);
  switch (layoutController.getCurrentLayout()) {
    case 'landscape_mobile': {
      resourceManager.get('GamCareContainer').visible = false;
      resourceManager.get('GamCareContainer_landscapeMobile:gamCareLogo').visible = isGamCareLogoVisible;
      resourceManager.get('GamCareContainer_landscapeMobile').visible =
        isGamCareLogoVisible || (isPreloadMessageVisible && loadingData.message.length != 0);
      break;
    }
    case 'landscape_default':
    case 'portrait_default':
    case 'portrait_mobile':
    default: {
      resourceManager.get('GamCareContainer_landscapeMobile').visible = false;
      resourceManager.get('GamCareContainer:gamCareLogo').visible = isGamCareLogoVisible;
      resourceManager.get('GamCareContainer').visible =
        isGamCareLogoVisible || (isPreloadMessageVisible && loadingData.message.length != 0);
      break;
    }
  }
};

Loader.onLayoutComplete = function () {
  Loader.setLoadProgress(1);
  messageBus.subscribe('spinner:GameConfigEvent', Loader.onGameConfigEvent);

  gameData.reels = [];
  for (let i = 0; i < gameData.numReels; i++) {
    const reel = resourceManager.get('slotContainer:reelContainer:reel' + i);
    gameData.reels.push(reel);
  }
};

Loader.setStartingSymbols = function () {
  for (var i = 0; i < 5; i++) {
    var reel = resourceManager.get('slotContainer:reelContainer:reel' + i);
    var startingSymbols = gameData.slotConfig.startingSymbols[i].symbols;

    //reel.setInjectors(preInjectorFactory.create(), postInjectorFactory.create());
    //reel.preInjector.initialise(0, 0, 0);

    //Generate last reel positions, only the symbols in view are passed to us so we need to generate the pre/post apperature symbols
    var symbol;
    for (let j = 0; j < 4; ++j) {
      if (j < 3) symbol = +startingSymbols[j].value;
      else symbol = Math.floor(Math.random() * 7);
      reel.setReelSymbol(j, symbol);
    }
  }
};

Loader.onGameConfigEvent = function (gameConfigTask) {
  gameData.slotConfig = gameConfigTask.data.slotConfig;
  gameData.maxExposure = gameConfigTask.data.maxExposure;

  // Link buttons to functions
  game.initialise(gameConfigTask);

  Loader.setStartingSymbols();

  if (gameConfigTask.data.savedClientData) {
    var encoreData = gameConfigTask.data.savedClientData.meta.find(function (element) {
      return element.name === 'encore';
    });
  }

  var enableEncoreButton = encoreData && encoreData.enabled;

  if (enableEncoreButton && !gameConfigTask.data.slotConfig.promotionActive) {
    // task.data.metaValue is set to true if recovering encore game
    gameData.encoreEnabled = true;

    // Put button in the right state if not already true
    var encoreButtonLB = resourceManager.get('goldenBetToggleButton');

    if (encoreButtonLB._flags.showLuckyBetActive !== gameData.encoreEnabled) {
      encoreButtonLB.setRecovery();
    }

    resourceManager.getController('stakeController').setStakeMultiplier(encoreData.value);
    game.changeStake(resourceManager.getController('stakeController').CurrentStake);
    game.resetWinnings();
    resourceManager.getController('stakeController').broadcastCurrentStake();
  }

  Loader.readyForSplash = true;
  Loader.checkCanGoToSplash();
};

Loader.checkCanGoToSplash = function () {
  if (Loader.readyForSplash && Loader.minTimerExpired) {
    Loader.setLoadProgress(1);

    let license = gameData.license.toUpperCase();
    if (license === 'BR' && gameData.recoveryStake !== undefined) {
      // Bit of a workaround to ensure that the full base game is displayed
      // including loading reels on BR licence in recovery
      Loader.readyForSplash = false;
      Loader.minTimerExpired = false;
      resourceManager.getContainer('loadingContainer').visible = false;
      gameController.slotMachine.update(0);
      game.goToSplash();
    } else {
      timerManager.addTimeout(250, function () {
        Loader.readyForSplash = false;
        Loader.minTimerExpired = false;
        resourceManager.getContainer('loadingContainer').visible = false;
        game.goToSplash();
      });
    }
  }
};

Loader.setLoadProgress = function (percent) {
  Loader.loadMask.scale.y = percent;
};
